
module dgUtils {

    export interface IDgLinksByRelFIlter extends Function {
        (links: dg.restfulApi.Links, relsIn: string | Array<string>): dg.restfulApi.Link[];
    }

    function dgLinksByRel($filter: dgUtils.IFilterService): IDgLinksByRelFIlter {
        return (links: dg.restfulApi.Links, relsIn: string | Array<string>) => {
            var rels = angular.isArray(relsIn) ? <Array<string>>relsIn : [<string>relsIn];
            return $filter('filter')((Object as any).values(links), (link: dg.restfulApi.Link, index) => {
                return rels.indexOf(link.rel) != -1;
            });

            //return $filter('filter')(_.values<dg.restfulApi.Link>(links), (link: dg.restfulApi.Link, index) => {
            //    return rels.indexOf(link.rel) != -1;
            //});
        }
    }
    angular.module('dgUtils')
        .filter('dgLinksByRel', ['$filter', dgLinksByRel]);
}